import React, { useState } from "react";

const Header = () => {
  const handleClick = (event) => {
    event.preventDefault(); // Prevent the default action
    console.log("Link click prevented!");
  };
  // const langus = document.documentElement.lang;
  // const [language, setLanguage] = useState("fr");
  // const langtobe = document.documentElement.lang === "fr" ? "en" : "fr";
  // const toggleLanguage = (e) => {
  //   // setLanguage((langus) => (langus === "fr" ? "en" : "fr"));
  //   // setLanguagetobe((langus) => (langus === "fr" ? "en" : "fr"));
  //   const newLang = language === "fr" ? "en" : "fr";
  //   // Update the lang attribute directly
  //   document.documentElement.lang = newLang;
  //   // Update the state
  //   setLanguage(newLang);
  // };
  return (
    <div>
      {/*=================================
 header */}

      {/** <header id="header" className="header default" style={{background:"none"}}>
       * replaced with style on the /assets/css/style.css:78 >> background: none; and background: #222c5a; from /assets/css/responsive.css:1269 form small screen
       */}
      <header id="header" className="header default">
        <div className="topbar">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 xs-mb-10">
                <div className="topbar-call text-center text-md-left">
                  <ul>
                    <li>
                      <i className="fa fa-envelope-o theme-color" />{" "}
                      <a
                        href="mailto:contact@sacemgroup.com"
                        style={{ fontSize: "15px" }}
                      >
                        contact@sacemgroup.com
                      </a>
                    </li>
                    {/* <li>
                      <i className="fa fa-phone" />{" "}
                      <a href="tel:0021671966986">
                        {" "}
                        <span>+(216) 71 966 986 </span>{" "}
                      </a>{" "}
                    </li>
                    */}
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="topbar-social text-center text-md-right">
                  <ul>
                    <li>
                      <a
                        href="/carrieres"
                        style={{ color: "white", fontSize: "15px" }}
                      >
                        Carrière
                      </a>
                    </li>
                    <li>
                      <a href="/pfebook" style={{ fontSize: "15px" }}>
                        PFE Book
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.facebook.com/sacemindustries/?locale=fr_FR"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ti-facebook" />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://fr.linkedin.com/company/sacem-group"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ti-linkedin" />
                      </a>
                    </li>
                    <li>
                      <a
                        className="nav-link dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span>FR&nbsp;</span>
                        <i className="fa fa-globe" />
                      </a>
                      <div
                        className="dropdown-menu "
                        x-placement="bottom-start"
                        style={{
                          position: "absolute",
                          transform: "translate3d(0px, 37px, 0px)",
                          top: 0,
                          left: 0,
                          willChange: "transform",
                          minWidth: "4rem",
                        }}
                      >
                        <ul
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <li
                            style={{
                              marginRight: "0%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <a href="/en" style={{ marginLeft: "0%" }}>
                              <img
                                src="/assets/images/language icon/en.png"
                                alt="en"
                              />
                            </a>
                          </li>
                          <li
                            style={{
                              marginRight: "0%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <a href="/" style={{ marginLeft: "0%" }}>
                              <img
                                src="/assets/images/language icon/fr.png"
                                alt="fr"
                              />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    {/* <li>
                      <a href="/en">
                        <img
                          src="/assets/images/language icon/en.png"
                          alt="en"
                        />
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*=================================
 mega menu */}
        <div className="menu">
          <centre>
            {/* menu start */}
            <nav id="menu" className="mega-menu">
              {/* menu list items container */}
              <section className="menu-list-items">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <ul className="menu-logo">
                        <li>
                          <a href="/">
                            <img
                              id="logo_img"
                              src="/assets/images/logos/logo1.png"
                              alt="SACEM Industries"
                            />{" "}
                          </a>
                        </li>
                      </ul>
                      {/* menu logo */}

                      {/* menu links */}
                      <div className="menu-bar">
                        <ul className="menu-links">
                          {/* HOME */}
                          <li>
                            <a href="/" style={{ fontSize: "18px" }}>
                              Accueil{" "}
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              onClick={handleClick}
                              style={{ fontSize: "18px" }}
                            >
                              {" "}
                              Entreprise{" "}
                              <i className="fa fa-angle-down fa-indicator" />
                            </a>
                            {/* drop down multilevel  */}
                            <div className="drop-down-multilevel">
                              <ul>
                                <li>
                                  <a
                                    href="/presentation"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-television" />
                                    Présentation{" "}
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/actualites"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-newspaper-o" />{" "}
                                    Actualités{" "}
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/histoire"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-history" />{" "}
                                    Histoire{" "}
                                  </a>
                                </li>
                                {/**<li>
                                  <a href="/rse">
                                    <i className="fa fa-handshake-o" /> R S E{" "}
                                  </a>
                                </li> */}

                                <li>
                                  <a
                                    href="/certificats"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-certificate" />{" "}
                                    Certification{" "}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li>
                            <a href="/durabilite" style={{ fontSize: "18px" }}>
                              Durabilité
                            </a>
                          </li>
                          <li>
                            <a href="/produits" style={{ fontSize: "18px" }}>
                              Produits{" "}
                              <i className="fa fa-angle-down fa-indicator" />
                            </a>
                            <ul className="drop-down-multilevel left-side">
                              <li>
                                <a
                                  href="/transformateurs"
                                  style={{ fontSize: "16px" }}
                                >
                                  Transformateurs
                                  <i className="ti-plus fa-indicator" />
                                </a>
                                {/* drop down second level */}
                                <ul className="drop-down-multilevel left-side">
                                  <li>
                                    <a
                                      href="/transformateur_dist_24"
                                      style={{ fontSize: "15px" }}
                                    >
                                      <i className="ti-plus fa-indicator" />
                                      Transformateurs de distribution Triphasé
                                    </a>
                                    {/* drop down third level */}
                                    <ul className="drop-down-multilevel left-side">
                                      <li>
                                        <a href="/transformateur_dist_24">
                                          Transformateur de distribution
                                          Triphasé classe 24KV
                                        </a>
                                      </li>
                                      <li>
                                        <a href="/transformateur_dist_36">
                                          Transformateur de distribution
                                          Triphasé classe 36KV
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a
                                      href="/transformateur_pui_triph"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Transformateurs de PUISSANCE Triphasé
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/transformateur_mono"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Transformateurs Monophasés
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/transformateur_special"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Transformateurs Spéciaux
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/transformateurs_photovoltaïques"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Transformateurs Photovoltaïques
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a
                                  href="/tableauMT-BT"
                                  style={{ fontSize: "16px" }}
                                >
                                  Tableau MT/BT
                                  <i className="ti-plus fa-indicator" />
                                </a>
                                {/* drop down second level */}
                                <ul className="drop-down-multilevel right-side">
                                  <li>
                                    <a
                                      href="/tableauais"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Tableau-AIS 36KV
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="Coffret_Protection_Transformateur"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Coffret Protection Transformateur
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/eems"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Système de Gestion de l'Energie
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/filtreactive"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Filtre active anti-harmoniques
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/batterie_condensateurs"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Batterie de condensateurs
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <a
                              href="#"
                              onClick={handleClick}
                              style={{ fontSize: "18px" }}
                            >
                              SERVICES{" "}
                              <i className="fa fa-angle-down fa-indicator" />
                            </a>
                            <ul className="drop-down-multilevel left-side">
                              <li>
                                {" "}
                                <a
                                  href="/services"
                                  style={{ fontSize: "16px" }}
                                >
                                  SAV & Réparation
                                </a>{" "}
                              </li>
                              <li>
                                <a
                                  href="/formation"
                                  style={{ fontSize: "16px" }}
                                >
                                  Formation
                                </a>
                              </li>
                            </ul>
                            {/* drop down full width */}
                          </li>

                          <li>
                            <a
                              href="/nouscontacter"
                              style={{ fontSize: "18px" }}
                            >
                              NOUS CONTACTER
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </nav>
            {/* menu end */}
          </centre>
        </div>
      </header>
    </div>
  );
};

export default Header;
